// extracted by mini-css-extract-plugin
export default {"formListWrapper":"TransactionVoucher_formListWrapper__hYdg5","btnPosition":"TransactionVoucher_btnPosition__3wzpk","warnInfo":"TransactionVoucher_warnInfo__R9SnJ"};